// Generated by CoffeeScript 2.5.1
  // Functions for scoring words

var lettersIn, wordScore,
  indexOf = [].indexOf;

lettersIn = function(word) {
  var j, len, letter, letters, ref;
  letters = [];
  for (j = 0, len = word.length; j < len; j++) {
    letter = word[j];
    if (ref = !letter, indexOf.call(letters, ref) >= 0) {
      letters.push(letter);
    }
  }
  return letters;
};

// Compute the word's score based on the candidates remaining. Higher is better.

// The score is a measure of the word's similarity to all other candidates (other than itself). The idea is that
// information gained from the word can be applied more of the other candidates.
wordScore = function(word, candidates) {
  var e, i, j, k, l, len, len1, letter, letters, ref, score;
  score = 0;
  // Get a list of different letters in word
  letters = lettersIn(word);
// Compare the word to each of the candidates
  for (j = 0, len = candidates.length; j < len; j++) {
    e = candidates[j];
    if (!e.word) {
      continue;
    }
    for (i = k = 0, ref = word.length; (0 <= ref ? k < ref : k > ref); i = 0 <= ref ? ++k : --k) {
      if (word[i] === e.word[i]) {
        // 4 points for each letter in the word that matches exactly
        score += 4;
      }
    }
// 1 point if the letter is in the word
    for (l = 0, len1 = letters.length; l < len1; l++) {
      letter = letters[l];
      if (indexOf.call(e.word, letter) >= 0) {
        // 1 point for each different letters that are in the word
        score += 1;
      }
    }
  }
  return score;
};

export default wordScore;
